import Converter = require("../../utils/ol3/converter");
import Portal = require("portal-gis");
import Utils = require("../../utils");
import Base = require("../base-command");
import geo = require("../../utils/geo");
import ol = require("ol");

// this command triggers one or more events, see base-command for rules
class Command extends Base<any> {

    static about = `
Put the current extent on the bus.

Usage Example:

\`\`\`xml
<EVENT 
    about="return map extent for filtering" 
    event="liferay:map-trace-extent"
    id="map-trace-extent-handler" 
    mid="app/commands/api/get-current-extent" />
\`\`\`

`;

    static options = {
        "trace": {
            "about": "true to write data to the console",
            "domain": "true|false",
            "default": "false",
        },
        "include-features": {
            "about": "true to include features that are within the extent",
            "domain": "true|false",
            "default": "false",
        },
    };

    static output = {
        "box": "the map extent",
        "center": "center of map",
        "extent": "the map extent",
        "layers": "the features within the map extent",
        "resolution": "map resolution",
        "rotation" : "map rotation",
        "wkid": "wkid of map projection",
        "zoom": "map zoom level",
    };

    execute(args: any = this.args) {
        if ("true" === this.findOption("trace")) {
            console.log(this);
        }
        this.mediator.mapViewMap(map => {
            let mapView = map.getView();
            let extent = mapView.calculateExtent(map.getSize());
            let wkid = mapView.getProjection().getCode();
            let transformer = geo.transformer(wkid, "EPSG:4326");
            let p0 = transformer.point([extent[0], extent[1]]);
            let p1 = transformer.point([extent[2], extent[3]]);

            let out = {
                box: p0.concat(p1),
                center: mapView.getCenter(),
                extent: p0.concat(p1),
                layers: [],
                resolution: mapView.getResolution(),
                rotation: mapView.getRotation(),
                wkid: wkid,
                zoom: mapView.getZoom(),
            };

            if ("true" === this.options["include-features"]) {

                let converter = new Converter(wkid);

                out.layers = map.getLayers().getArray()
                    .filter(l => l instanceof ol.layer.Vector)
                    .map(l => <ol.layer.Vector>l)
                    .filter(l => l.getVisible())
                    .map(l => {
                        // spoof a query result container
                        let layer = <Rhythm.GIS.FeatureQueryResultLayer>{
                            _extensions_: Utils.getExtensionKey(l, true),
                            features: []
                        };

                        // spoof query results
                        let source = l.getSource();

                        let features = source.getFeaturesInExtent(extent);
                        layer.features = layer.features.concat(converter.fromNativeFeatures(features).features);

                        return layer;
                    });

            }

            this.trigger(out);
        })
    }

}

export = Command; 